import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { PrimaryButton, SecondaryButton } from '@/components/index';

export interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title?: string;
  itemType: string; // e.g., "quotation", "quotation request", "service", etc.
  itemId: string | null;
  customMessage?: string;
}

export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  itemType,
  itemId,
  customMessage
}) => {
  const handleConfirm = async () => {
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      // Error handling is done in the parent component/hook
      console.error('Delete confirmation failed:', error);
    }
  };

  const defaultMessage = `Are you sure you want to delete ${itemType} "${itemId}"? This action cannot be undone.`;
  const message = customMessage || defaultMessage;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
        <PrimaryButton onClick={handleConfirm} color="error">
          Delete
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};